module.exports = __webpack_public_path__ + "static/img/13.014a512.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/13.png
// module id = 5cn4
// module chunks = 0